import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../constants/axiosInstance';

const fetchDescription = async (insightId: string): Promise<string> => {
  const { data } = await axiosInstance().post('insights/getAiGeneratedInsightDescription', { insightId });
  return data?.data?.description;
};

export const useInsightDescription = (insightId: string) => {
  const {
    data: description,
    isLoading,
    isFetching,
    error,
    refetch: refetchDescription,
  } = useQuery({
    queryKey: ['insightDescription', insightId],
    queryFn: () => fetchDescription(insightId),
    enabled: false,
  });
  return { description, isLoading,isFetching,  error, refetchDescription };
};
